import { ISearchNodesState } from "source/app/presentation/MainPanel/Workflows/SearchNodes/Helpers/ISearchNodesState";
import { ESharedComponent } from 'source/app/services/UI/State/ESharedComponent';
import { State } from 'source/app/services/UI/State/State';

export function ClearSearch() {
	const searchNodes = State.ReadClass<ISearchNodesState>(
		ESharedComponent.SearchNodes
	);

	if (searchNodes) {
		searchNodes.setState({
			searchText: '',
			filteredNodes: [],
			showFavorites: true
		});
	}
}
